moment.locale('lt');
tinyMCE.baseURL = "/static/dist/tinymce";